module.exports = __webpack_public_path__ + "img/recruit_header.7463b0fb.jpg";